$('.stopMotion').slick({
    infinite: false,
    dots: false,
    arrows: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    fade:true,
    autoplaySpeed: 6000,
    cssEase: 'linear'
  });

$(".stickyLink").click(function () {
  $("html, body").animate({
    scrollTop: ($($(this).attr("href")).offset().top - 200 )
  })
});

$('.subnav > a').click(function(e){
  e.preventDefault();
  $(this).parent('li').toggleClass('active');
})

$('.videoHover').hover(function() {
  var vid = $(this).attr('id');
  $('#'+ vid + '').trigger('play');
});

$('.accordion .item').click(function(){
  $(this).toggleClass('open');
})

$('.grandchild li').each(function() {
  if ($(this).hasClass('active')) {
    $(this).closest('.subnav').addClass('active');
  }
});


$('.readmore').click(function (event) {
  event.preventDefault();
  var descriptionFull = document.querySelector('.product-description-full');
  descriptionFull.style.display = 'block';
  var descriptionShort = document.querySelector('.product-description-short');
  descriptionShort.style.display = 'none';
});
$('.readless').click(function (event) {
  event.preventDefault();
  var descriptionFull = document.querySelector('.product-description-full');
  descriptionFull.style.display = 'none';
  var descriptionShort = document.querySelector('.product-description-short');
  descriptionShort.style.display = 'block';
});


$(document).ready(function () {
  $('#bta-widget-container').find('iframe').load(function () {
    $('.date-picker-container').hide();
  });
});